import { Component, ElementRef, Inject, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { User } from 'src/app/domain/user';
import { UserService } from 'src/app/services/user.service';
import { StringTool } from '../../mapping/string.tool';
import { NgModel, ValidationErrors } from '@angular/forms';

@Component({
    selector: 'app-alternate-contact-box',
    templateUrl: './alternate-contact-box.component.html',
    styleUrls: ['./alternate-contact-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlternateContactBoxComponent implements OnInit {
    @ViewChild('email') emailInput: NgModel;
    Model: User = new User();
    clientCode: string;
    ClientContactList: User[] = [];
    AlreadyAddedContactList: User[] = [];
    IsCreation = false;

    constructor(
        public dialogRef: MatDialogRef<AlternateContactBoxComponent>,
        private userService: UserService,
        @Inject(MAT_DIALOG_DATA) public data) {
        this.clientCode = data.clientCode;
        this.AlreadyAddedContactList = data.alreadyAddedContactList;
    }

    ngOnInit(): void {
        this.userService.getAlternateContactListByClient(this.clientCode).subscribe(x => {
            this.ClientContactList = x.filter(c => !this.AlreadyAddedContactList.find(a => a.Email === c.Email));
        });
    }

    setCreationMode() {
        this.Model = new User();
        this.IsCreation = !this.IsCreation;
    }

    CanSave() {
        if (this.IsCreation)
            return StringTool.isNotNullOrEmpty(this.Model.FirstName)
                && StringTool.isNotNullOrEmpty(this.Model.LastName)
                && StringTool.isNotNullOrEmpty(this.Model.Phone)
                && StringTool.isNotNullOrEmpty(this.Model.Email)
                && this.emailInput.valid;
        return this.Model.Email;
    }

    onCancel(): void {
        this.dialogRef.close();
    }

    onConfirm() {
        if (this.CanSave())
            this.dialogRef.close(this.Model);

    }

    public compareUserWith(m1: User, m2: User) {
        return m1 && m2 ? m1.Email === m2.Email : m1 === m2;
    }
}
